import { nanoid } from 'nanoid'

export function generateId(): string {
  return nanoid(12)
}

export function createTimestamps() {
  const now = new Date().toISOString()
  return {
    createdAt: now,
    updatedAt: now,
  }
}

export function updateTimestamp() {
  return {
    updatedAt: new Date().toISOString(),
  }
}
